import { useEffect, useMemo } from 'react'
import {
    IClipboardItem,
    useClipboardStorageState,
} from 'store/clipboardStore/clipboardStore'

export function useClipboardStorage<T extends IClipboardItem = IClipboardItem>(
    type: 'descriptors' | 'qualifiers'
) {
    const [state, actions] = useClipboardStorageState()

    useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (event.key === 'clipboardStorage' && event.newValue) {
                actions.syncFromStorage()
            }
        }
        window.addEventListener('storage', onStorage)
        return () => {
            window.removeEventListener('storage', onStorage)
        }
    }, [actions])

    const items = state[type]

    return useMemo(
        () => ({
            items,
            addItem: (item: T) => actions.addItem(type, item),
            removeItem: (ui: string) => actions.removeItem(type, ui),
            clearItems: () => actions.clearItems(type),
        }),
        [items, actions, type]
    )
}
